import { motion, useReducedMotion } from 'motion/react'

import { Footer } from './Footer'
import { Header } from './Header'

export function AppShell({ children, currentPage }) {
  const reduceMotion = useReducedMotion()

  return (
    <div className="page-shell">
      <a className="skip-link" href="#main-content">
        Saltar al contenido
      </a>
      <Header currentPage={currentPage} />
      <motion.main
        id="main-content"
        initial={reduceMotion ? false : { opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.45 }}
      >
        {children}
      </motion.main>
      <Footer />
    </div>
  )
}
